var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVisa = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.807,
    height: 18.429,
    viewBox: "0 0 56.807 18.429",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "visa",
    transform: "translate(-5.346 -24.536)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_74",
    "data-name": "Grupo 74",
    transform: "translate(5.346 24.536)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_205",
    "data-name": "Trazado 205",
    d: "M35.852,69.641H31.217l2.9-17.8H38.75Zm-8.535-17.8L22.9,64.083l-.523-2.637h0l-1.56-8.007a1.984,1.984,0,0,0-2.2-1.6H11.312l-.086.3a17.341,17.341,0,0,1,4.849,2.035L20.1,69.642h4.83l7.375-17.8H27.318Zm36.459,17.8h4.256l-3.711-17.8H60.6a2.13,2.13,0,0,0-2.14,1.327L51.543,69.641h4.832L57.341,67h5.893l.543,2.645Zm-5.1-6.3,2.436-6.663,1.37,6.663Zm-6.771-7.225.662-3.823a13.379,13.379,0,0,0-4.169-.776c-2.3,0-7.763,1.005-7.763,5.894,0,4.6,6.411,4.657,6.411,7.073s-5.751,1.983-7.649.46l-.689,4a12.99,12.99,0,0,0,5.232,1.005c3.163,0,7.935-1.638,7.935-6.1,0-4.629-6.469-5.06-6.469-7.073s4.515-1.755,6.5-.662Z",
    transform: "translate(-11.226 -51.519)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_206",
    "data-name": "Trazado 206",
    d: "M22.376,61.8l-1.56-8.007a1.984,1.984,0,0,0-2.2-1.6H11.312l-.086.3a17.96,17.96,0,0,1,6.879,3.454A13.883,13.883,0,0,1,22.376,61.8Z",
    transform: "translate(-5.88 -27.332)",
    fill: "#e6a540"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVisa);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/visa.626ef4185b0efe71cc11ae19ada004ff.svg";